<template>
    <div class="border-radio"  :class="{'border-radio--active': val===value, 'border-radio--disabled': isDisabled}">
        <label class="border-radio__radio  vh-center pointer" :class="{'border-radio__radio--active': val===value}">
            <input type="radio" :value="val" v-model="checked" @change="onChange" />
            {{text}}
        </label>
    </div>
</template>
<script>
export default {
    data () {
        return {
            isChecked: this.isPropChecked,
            checkVal: '',
        }
    },
    props: {
        text: {
            type: String,
            default: true,
        },
        isPropChecked: {
            type: Boolean,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        val: null,
        value: null,
    },
    watch: {
        isPropChecked: function (val) {
            this.isChecked = val
        },
    },
    methods: {
        onChange: function(e) {
            this.isChecked = true;
            this.$emit('input', this.checkVal)
        }
    },
    computed: {
        checked: {
            get () {
                return this.value
            },
            set (val) {
                this.checkVal = val
            }
        }
    },
}
</script>
<style lang="scss" scoped>
    .border-radio{
        position: relative;
        font-size: 14px;
        color: #676362;
        height: 44px;
        border: solid 1px #c5c2c1;
        border-radius: 4px;
        input{
            display: none;
        }
        &--disabled {
            pointer-events:none;
            border: solid 1px #d5d8e0;
            color: #aeb1b6;
        }
        &__radio{
            font-size: 14px;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }
        &--active{
            color: #ff9275;
            border: solid 1px #ff9275;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/bussiness/widges/input/borderRadio.vue